// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"55":"0fddbbc2972d9329","248":"64de9000568be379","348":"40f49066fae604db","597":"61f0c0fcf9daf8a5","676":"ba6af5ce1f5388d0"}[chunkId] + ".js";
};